import { useQuery } from "@tanstack/react-query";
import { PersonLanguage } from "../../models/languageSkill.model";
import { LanguageSkillService } from "../../services/languageSkillService";

const languageSkillService = new LanguageSkillService();

export const useLanguageSkills = (personId: number) => {
  return useQuery({
    queryKey: ["languageSkills", personId],
    queryFn: (): Promise<PersonLanguage[]> => {
      return languageSkillService.getDataByPersonID(personId);
    },
    enabled: !!personId && personId > 0,
    staleTime: 1000 * 60 * 10, // 10 minutes - language skills don't change often
    gcTime: 1000 * 60 * 30, // 30 minutes
  });
};
